import { render, staticRenderFns } from "./stockroom_select.vue?vue&type=template&id=55a51fbf&"
import script from "./stockroom_select.vue?vue&type=script&lang=js&"
export * from "./stockroom_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports